// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\WidgetGiftcardOrderResponse

import { GiftcardOrderStatus } from './enums.gen';
import { DateTimefromISO } from '#lib/helper/date.js';
import type { DateTime } from 'luxon';

export type WidgetGiftcardOrderApiResponse = {
	id: number;
	createdAt: string;
	quantity: number;
	amount: number;
	bookableGiftcardId: string | null;
	senderFirstName: string | null;
	senderLastName: string | null;
	message: string | null;
	sendDate: string | null;
	status: GiftcardOrderStatus | null;
	senderEmail: string | null;
	discountAmount: number | null;
	discountCode: string | null;
};

export type WidgetGiftcardOrder = {
	id: number;
	createdAt: DateTime;
	quantity: number;
	amount: number;
	bookableGiftcardId: string | null;
	senderFirstName: string | null;
	senderLastName: string | null;
	message: string | null;
	sendDate: DateTime | null;
	status: GiftcardOrderStatus | null;
	senderEmail: string | null;
	discountAmount: number | null;
	discountCode: string | null;
};

export function hydrateWidgetGiftcardOrder(data: WidgetGiftcardOrderApiResponse): WidgetGiftcardOrder {
	return {
		...data,
		createdAt: DateTimefromISO(data.createdAt)!,
		sendDate: DateTimefromISO(data.sendDate),
	};
}